export default __webpack_public_path__ + "static/media/Blooded Belt of the Plains.855e1656.jpg";